import { EColors } from "common/styles";

export const products = [
    {
        name: "95",
        price: "47",
        coins: "80",
        color: `${EColors.primary_100}`,
    },
    {
        name: "ДП",
        price: "44",
        coins: "00",
        color: `${EColors.accent_100}`,
    },
    {
        name: "Газ",
        price: "22",
        coins: "20",
        color: `${EColors.white}`,
    },
];